import { columnsLinks } from '@/domain/env/colums-links';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { Link } from '@/domain/types/collections';
import useGetDocuments from '@/domain/use-cases/get-documents';
import Button from '@/presentation/components/button';
import Table from '@/presentation/components/table';
import { FiPlus } from 'react-icons/fi';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

const LinksPage = () => {
  const navigate = useNavigate();
  const { data, error, isLoading } = useGetDocuments<Link[]>(
    DOCUMENTS_DB.LINKS,
  );

  if (isLoading) return <div>Loading...</div>;

  if (error) return <div>Error: {error}</div>;

  if (!data) return <div>No hay datos</div>;

  const handleRowClick = (row: Link) => {
    navigate(`/dashboard/links/details/${row.id}`);
  };

  return (
    <div className="p-4 flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Enlaces</h1>

        <RouterLink to="/dashboard/links/add">
          <Button label="Agregar enlace" icon={<FiPlus />} onClick={() => {}} />
        </RouterLink>
      </div>

      <Table data={data} columns={columnsLinks} onRowClick={handleRowClick} />
    </div>
  );
};

export default LinksPage;
